import EmptyObject from "@coworker/apprestructured/src/task-management/types/EmptyObject";
import {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { Ref, useCallback } from "react";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import AttachFiles from "@coworker/apprestructured/src/task-management/components/AttachFiles/AttachFiles";

const EMPTY_FILE_ARRAY: File[] = [];

export type AttachFilesCreatorFragmentConfigProps = EmptyObject;

type AttachFilesCreatorFragmentProps = {
  configProps: AttachFilesCreatorFragmentConfigProps;
  commonProps: CreatorFragmentCommonProps;
  ref?: Ref<CreatorFragmentHandle>;
};

function AttachFilesCreatorFragment({
  commonProps,
}: AttachFilesCreatorFragmentProps) {
  const { blockInput, task, onTaskChange } = commonProps;
  const images = getByPath<File[]>(task, "files");
  const handleFilesChanged = useCallback(
    (newFiles: File[]) => {
      onTaskChange({ files: newFiles });
    },
    [onTaskChange]
  );

  return (
    <AttachFiles
      files={isLoading(images) ? EMPTY_FILE_ARRAY : images}
      onFilesChanged={handleFilesChanged}
      disabled={blockInput || isLoading(images)}
    />
  );
}

export default AttachFilesCreatorFragment;
